<template>
  <div class="share-container">
    <div class="share-main">
      <img src="../assets/images/reports-success.png" alt="">
      <p class="tips">共享成功</p>
      <div class="coins">+{{coins}}学贝</div>
      <router-link to="/" class="back-home">返回组卷</router-link>
    </div>
  </div>
</template>

<script>
var that
export default {
  name: 'shareSuccess',
  data() {
    return {
      coins: 0
    }
  },
  created() {
    that = this
    if(Object.keys(this.$route.query).length) {
      that.coins = this.$route.query.coins
    }
  }
}
</script>

<style lang="scss" scoped>
.share-container {
  width: 100%;
  padding-top: 20px;
  .share-main {
    margin: 0 auto;
    padding: 100px 10px 200px;
    width: 1200px;
    min-width: 1200px;
    background-color: #fff;
    text-align: center;
    .tips {
        margin: 20px 0;
    }
    .coins {
        color: red;
        margin: 10px 0;
        font-size: 16px;
        letter-spacing: 2px;
    }
    .back-home {
        display: block;
        margin: 20px auto 0;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #2b99ff;
        color: #fff;
        cursor: pointer;
        &:hover {
        background-color: #067ff3;
        }
    }
  }
}
</style>
